export default __webpack_public_path__ + "assets/slovakia-flag.png";